import vuexStore from '@evolve/store'
import { registerAndGetStore as buildAndRegisterStoreObject } from 'vuex-stores'

// Public: Registers the module in the Vuex store, and returns a set of helpers.
export function registerAndGetStore (moduleNamespace, moduleConfig) {
  return buildAndRegisterStoreObject(vuexStore, { namespace: moduleNamespace, ...moduleConfig })
}
